import { CustomQueryOptions } from '@/common/types_and_interfaces'
import { MarketplaceStorePaginated } from '@/queries/marketplace/schema'
import { useQuery } from '@tanstack/react-query'
import {
  GETMarketplacePreviewStores,
  MarketplacePreviewStoresParams,
} from '../requests'
import { MARKETPLACE_PREVIEW_QUERY_KEYS } from './keys'
import { MarketplaceAccessMode } from '../types'

export const useMarketplacePreviewStores = (
  params: MarketplacePreviewStoresParams,
  mode: MarketplaceAccessMode = 'preview',
  options: CustomQueryOptions<MarketplaceStorePaginated> = {}
) => {
  return useQuery({
    queryFn: () => GETMarketplacePreviewStores(params, mode),
    queryKey: MARKETPLACE_PREVIEW_QUERY_KEYS.stores(mode, params),
    ...options,
  })
}
